import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Form,
  Modal,
  Alert,
  Container,
  Row,
  Col,
  Pagination,
  CardGroup,
} from "react-bootstrap";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import { MenuItem, Popper } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Twitter from "@material-ui/icons/Twitter";
import WhatsApp from "@material-ui/icons/WhatsApp";
import Facebook from "@material-ui/icons/Facebook";
import LinkedIn from "@material-ui/icons/LinkedIn";
import Instagram from "@material-ui/icons/Instagram";
import Mail from "@material-ui/icons/Mail";
import { Helmet } from "react-helmet";
import "./blogPost.scss";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import DeleteIcon from "@material-ui/icons/Delete";

import {
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  HatenaShareButton,
  InstapaperShareButton,
  LineShareButton,
  LinkedinShareButton,
  LivejournalShareButton,
  MailruShareButton,
  OKShareButton,
  PinterestShareButton,
  PocketShareButton,
  RedditShareButton,
  TelegramShareButton,
  TumblrShareButton,
  TwitterShareButton,
  ViberShareButton,
  VKShareButton,
  WhatsappShareButton,
  WorkplaceShareButton,
} from "react-share";
import CardContent from "@material-ui/core/CardContent";
import Collapse from "@material-ui/core/Collapse";
import { red } from "@material-ui/core/colors";
import DateRangeTwoToneIcon from "@material-ui/icons/DateRangeTwoTone";
import ChatOutlinedIcon from "@material-ui/icons/ChatOutlined";
import ShowMore from "react-show-more";
import firebase from "../../../firebase";
import { data } from "../../../firebase";
import { useForm } from "react-hook-form";
import { NavLink } from "react-router-dom";

const classes = {
  socialMediaPopper: {
    top: "300px  !important",
    left: "unset !important",
    right: "0px !important",
    display: "grid",
  },
  socialMediaButton: {
    "&:hover > svg": {
      height: "50px !important",
      width: "50px !important",
    },
  },
};
const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: red[500],
  },
}));
export const BlogPost = (props) => {
  const [items, setItems] = useState([]);
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [comment, setComment] = useState(false);
  const ref = firebase.collection("/blog");
  function getData() {
    ref.onSnapshot((data) => {
      const item = [];
      data.forEach((doc) => {
        item.push(doc.data());
      });
      setItems(item);
      setRecent(
        item.sort((a, b) => {
          return b.id - a.id;
        })
      );
    });
  }
  const [post, setPost] = useState({
    id: 1,
    content:
      '<div dir="ltr" style="text-align: left;" trbidi="on"> <h2 style="text-align: left;"><div class="separator" style="clear: both; text-align: center;"> <a href="https://3.bp.blogspot.com/-EFlPRBNf_Q4/XEEjGLKGbmI/AAAAAAAAOTY/rYLM-pKAoQA1jG-km8SvXz0fKG2A4IpZgCLcBGAs/s1600/Screenshot_7.png" style="margin-left: 1em; margin-right: 1em;"><img border="0" data-original-height="124" data-original-width="184" height="134" src="https://3.bp.blogspot.com/-EFlPRBNf_Q4/XEEjGLKGbmI/AAAAAAAAOTY/rYLM-pKAoQA1jG-km8SvXz0fKG2A4IpZgCLcBGAs/s200/Screenshot_7.png" width="200" /></a></div> Machine Learning with python&nbsp;</h2> <h4 style="text-align: left;"> <span style="font-weight: normal;">Data preprocessing&nbsp; for a given data set</span></h4><div> <span style="font-weight: normal;"><br /></span></div> <div> <span style="font-weight: normal;">lets start::::::</span></div> <div> <b>step 1:</b>create a dataset for n rows and n cols</div> <div> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;here is a example dataset-</div> <div class="separator" style="clear: both; text-align: center;"> <img border="0" data-original-height="176" data-original-width="506" height="220" src="https://3.bp.blogspot.com/-_uS4denPi3k/XEEcXLLqabI/AAAAAAAAOSY/cTSXXh-2J2IkvIG0f8P2vtCXt3AiKmuJQCLcBGAs/s640/Screenshot_1.png" width="640" /></div> <h4 style="text-align: left;"> Step 2: Now first step is to read the .csv file using pandas library</h4> <div> <b>code:</b></div> <div> #read file using pandas</div> <div> import pandas as pd</div> <div> data=pd.read_csv("gata.csv")</div> <h4 style="text-align: left;"> Step 3 :Now divide the data set into input data set and output dataset</h4> <div> <b>code:</b></div> <div> <div> #now dive datat set in inputs and output</div> <div> X=data.iloc[ : ,0:3].values</div> <div> Y=data.iloc[ : ,3:4].values</div> </div> <div class="separator" style="clear: both; text-align: center;"> <img border="0" data-original-height="115" data-original-width="528" height="137" src="https://1.bp.blogspot.com/-1_HabY7f87o/XEEd1okTL_I/AAAAAAAAOSk/svuvposMv68ZiN7Slx8TdDurEZr9lXPSwCLcBGAs/s640/Screenshot_2.png" width="640" /></div> <div> hence created X and Y input and output sets respectively</div> <h4 style="text-align: left;"> Step 4 :Now removing the null(nan or empty) values from the input data set</h4> <div> <b>code:</b></div> <div> <div> #new replacing the nan with some value using imputer</div> <div> from sklearn.preprocessing import Imputer</div> <div> imp=Imputer(strategy="mean")</div> <div> X[ : ,1:3]=imp.fit_transform(X[ : ,1:3])</div> </div> <div class="separator" style="clear: both; text-align: center;"> <img border="0" data-original-height="114" data-original-width="357" height="127" src="https://3.bp.blogspot.com/-VoZcDzhareE/XEEe7HHfMKI/AAAAAAAAOS0/J4Ptsj0qlyAWfsDi5FcO_NAl2og4sSSYwCLcBGAs/s400/Screenshot_3.png" width="400" /></div> <div> <br /></div> <h4 style="text-align: left;"> </h4> <div> <br /></div> <div> <br /></div> <div> <br /></div> <div> <br /></div> <h4 style="text-align: left;"> step 5: Now giving the distinct values for country in dataset</h4> <div> <b>code:</b></div> <div> <div> #now lable encoder ie catogories for country</div> <div> from sklearn.preprocessing import LabelEncoder</div> <div> le=LabelEncoder()</div> <div> X[ : ,0]=le.fit_transform(X[ : ,0])</div> </div> <div class="separator" style="clear: both; text-align: center;"> <img border="0" data-original-height="111" data-original-width="305" height="145" src="https://2.bp.blogspot.com/-42IuNQrhsDA/XEEfyRnUY4I/AAAAAAAAOS8/zzZzK0aCh8saHANqrpsYmQt1wGJ3y7ntQCLcBGAs/s400/Screenshot_4.png" width="400" /></div> <div> <br /></div> <div> <br /></div> <div> <br /></div> <div> <br /></div> <div> <br /></div> <div> <br /></div> <div> <br /></div> <div> <br /></div> <div> <br /></div> <h4 style="text-align: left;"> Step 6:Now making the categorical inputs according to country</h4> <div> <b>code:</b></div> <div> <div> #now onehotencoder for make categories according to country</div> <div> from sklearn.preprocessing import OneHotEncoder</div> <div> ohe=OneHotEncoder(categorical_features=[0])</div> <div> X=ohe.fit_transform(X).toarray()</div> </div> <div class="separator" style="clear: both; text-align: center;"> <img border="0" data-original-height="116" data-original-width="495" height="148" src="https://2.bp.blogspot.com/-l4cgi5GlKU0/XEEgmUqOVMI/AAAAAAAAOTE/AtpCNUE_SY4BLMLzh0y6463Ngs5EjgowQCLcBGAs/s640/Screenshot_5.png" width="640" /></div> <h4 style="text-align: left;"> Step 7:Now standard scaling function</h4> <div> code:</div> <div> <div> from sklearn.preprocessing import StandardScaler</div> <div> ss=StandardScaler()</div> <div> X=ss.fit_transform(X)</div> </div> <div class="separator" style="clear: both; text-align: center;"> <img border="0" data-original-height="180" data-original-width="621" height="184" src="https://1.bp.blogspot.com/-5-YKTYqSTRA/XEEhPGf32XI/AAAAAAAAOTM/hyB-_ugkUIE-VyWdEI9X75dZYjCp0fU2QCLcBGAs/s640/Screenshot_6.png" width="640" /></div> <div> hence the data processing is done :p</div> <div> <br /></div> <div> <br /></div> <h3 style="text-align: left;"> Links for download:🔺🔻🔺🔻</h3> <h3 style="text-align: left;"> <a href="https://drive.google.com/file/d/1wzU-_MV3dYJEbLSTzHFnpjuyhFBMaAfd/view?usp=sharing" target="_blank">Dataset</a>&nbsp;&nbsp;<a href="https://drive.google.com/file/d/10Pwb6B2LliqrfvROzheHxml7cW1N96w7/view?usp=sharing" target="_blank">python code</a></h3> <div> <br /></div> </div> ',
    heading: "abc",
  });

  console.log("post -->", post);
  useEffect(() => {
    getData();
    reset();
   
  }, []);

  useEffect(() => {
    var blogTitle = props.match.params.blogTitle;
    // console.log("blogTitle ----->", blogTitle);

    if (blogTitle === undefined || blogTitle === "2") {
      blogTitle = "a-complete-social-media-marketing-guide-for-startup";
    }
    const post = items.find((data) => data.title == blogTitle);
    // console.log("post ------------------------------------------------->", post);

    setPost(post);
    setLoading(false);
  });
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const create = (tutorial, id) => {
    return firebase
      .collection("blog")
      .doc(post.docId)
      .update({
        comment: data.arrayUnion(tutorial),
      });
  };
  const { register, handleSubmit, errors, reset, watch, formState } = useForm();
  const onSubmit = (data) => {
    create(data, post.docId);
    reset();
  };
  if (loading) {
    return <h1></h1>;
  }

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" name="CloudSocial Blog page" />
        {post === undefined ? (
          <title>Blog</title>
        ) : (
          <title>{post.metaTitle}</title>
        )}
        <meta name='description' content={post?.metaData} data-react-helmet="true"/>

        {post === undefined ? (
          <link href="https://cloudsocial.io/blog" />  //rel="canonical"
        ) : (
          <link  href={`https://cloudsocial/${post.title}`} /> //rel="canonical"
        )}
      </Helmet>
      {/* <h1 className="blogHeading">Social Media Marketing Tool</h1> */}
      <NavLink className="recentBlogNavLink" to={`/blog`}>
        {/* <h6>
          <Badge bg="secondary">Back</Badge>
        </h6> */}
        <ArrowBackIosIcon fontSize="small" />
        Back
      </NavLink>

      <Card className="blogCard">
        {post == undefined ? (
          <></>
        ) : (
          <Card.Img
            variant="top"
            className="blogImage"
            src={post.blogImage}
            alt={post.heading}
          />
        )}
        <Card.Body>
          {/* <Card.Title className="blogTitle">{post.heading}</Card.Title> */}
          <Card.Text className="blogText">
            {/* <ShowMore
              lines={5}
              more="Read more"
              less="Read less"
              anchorClass=""
            > */}
            <div>
              {post === undefined ? (
                <div>loading ...</div>
              ) : (
                <div dangerouslySetInnerHTML={{ __html: post.content }} />
              )}
            </div>
            {/* </ShowMore> */}
          </Card.Text>
          <Card.Footer className="blogFooter">
            <small className="text-muted ">
              <DateRangeTwoToneIcon
                style={{ fontSize: 20, marginRight: "5px" }}
              />
              {post === undefined ? <></> : post.date}
            </small>
            <small
              className="text-muted "
              onClick={() => {
                setComment(!comment);
              }}
              style={{ cursor: "pointer" }}
            >
              <ChatOutlinedIcon
                style={{
                  fontSize: 20,
                  marginRight: "5px",
                  cursor: "pointer",
                }}
              />
              Comments
            </small>
            <LongMenu />
          </Card.Footer>

          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <CardContent>
              {/* <Typography paragraph>{post.blogTextParagraph}</Typography> */}

              <Typography></Typography>
            </CardContent>
          </Collapse>
          <div className={`${comment ? "commentGet" : "commentHide"}`}>
            <div>
              {post === undefined ? (
                <></>
              ) : (
                post.comment.map((re) => {
                  return (
                    <div>
                      <div className="name">{re.name}</div>
                      <div className="comment">{re.comment}</div>
                      <hr />
                    </div>
                  );
                })
              )}
            </div>
            <hr />
            <h6 className="addComment">Add your Comment</h6>
            <Form
              className="form"
              onSubmit={handleSubmit(onSubmit)}
              style={{ fontFamily: "Montserrat !important" }}
            >
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter name"
                  name="name"
                  autoComplete="off"
                  aria-invalid={errors.name ? "true" : "false"}
                  ref={register({ required: true })}
                  className="emailInput"
                  required
                  id="data1"
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  name="emailId"
                  autoComplete="off"
                  aria-invalid={errors.emailId ? "true" : "false"}
                  ref={register({ required: true })}
                  className="emailInput"
                  required
                  id="data1"
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Comment</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Add comment"
                  name="comment"
                  autoComplete="off"
                  aria-invalid={errors.emailId ? "true" : "false"}
                  ref={register({ required: true })}
                  className="emailInput"
                  required
                  id="data1"
                />
                {errors.emailId && (
                  <span role="alert">This field is required</span>
                )}
              </Form.Group>
              <Button className="letterButton" letiant="primary" type="submit">
                Submit
              </Button>
            </Form>
          </div>
        </Card.Body>
      </Card>
      {/* <Card className="blogCard mt-3">
        <Card.Img
          variant="top"
          className="blogImage"
          src=""
          alt="img"
        />
      </Card> */}
      <Row xs={1} md={2} className="g-5 blogCard mt-5">
        {recent.slice(0, 4).map((post) => {
          const { id, heading, blogImage, content, date, auther } = post;
          return (
            <Col
              key={id}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <CardGroup>
                <NavLink
                  className="recentBlogNavLink"
                  key={id}
                  to={`/blog/${post.title}`}
                >
                  <Card style={{ margin: "5px" }} text="dark" className="blogs">
                    <Card.Img variant="top" src={blogImage} />
                    <Card.Body>
                      <Card.Text>{heading}</Card.Text>
                      <Card.Footer
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <small className="text-muted recentPostedOn">
                          {date}
                        </small>
                        <small className="text-muted recentPostedOn">
                          by : {auther}
                        </small>
                      </Card.Footer>
                    </Card.Body>
                  </Card>
                </NavLink>
              </CardGroup>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};
//var link = window.location.href;
var link = document.URL;

// var url = window.location.pathname;

const options = [
  <FacebookShareButton
    title="Share - CloudSocial Blog"
    url={link}
    hashtag="#cloudsocial"
    className={classes.socialMediaButton}
  >
    <Facebook />
  </FacebookShareButton>,
  <InstapaperShareButton
    title="Share - CloudSocial Blog"
    url={link}
    hashtag="#cloudsocial"
    className={classes.socialMediaButton}
  >
    <Instagram />
  </InstapaperShareButton>,
  <LinkedinShareButton
    title="Share - CloudSocial Blog"
    url={link}
    hashtag="#cloudsocial"
    className={classes.socialMediaButton}
  >
    <LinkedIn />
  </LinkedinShareButton>,
  <WhatsappShareButton
    title="Share - CloudSocial Blog"
    url={link}
    hashtag="#cloudsocial"
    className={classes.socialMediaButton}
  >
    <WhatsApp />
  </WhatsappShareButton>,
  <TwitterShareButton
    title="Share - CloudSocial Blog"
    url={link}
    hashtag="#cloudsocial"
    className={classes.socialMediaButton}
  >
    <Twitter />
  </TwitterShareButton>,
  <EmailShareButton
    title="Share - CloudSocial Blog"
    url={link}
    hashtag="#cloudsocial"
    className={classes.socialMediaButton}
  >
    <Mail />
  </EmailShareButton>,
];

const ITEM_HEIGHT = 30;

export function LongMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>

      <Popper className={classes.socialMediaPopper} open={true} transition>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              // maxHeight: ITEM_HEIGHT * 4.5,
              //width: "30ch",
              display: "flex",
              // flexDirection:"row"
            },
          }}
          className="shareMenu"
        >
          {options.map((option) => (
            <MenuItem
              key={option}
              selected={option === "Pyxis"}
              onClick={handleClose}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      </Popper>
    </div>
  );
}
